import axios from "axios";
import RenderToast from "../components/RenderToast";
import {signOutRequest} from "@/store/auth/authSlice";
import config from "@/config";
import store from "@/store";

const axiosInstance = axios.create({
  baseURL: config.api.baseEndpoint + '/api/',
});

axiosInstance.interceptors.request.use(
  config => {
    if (!config.headers.Authorization) {
      const token = store.getState().authReducer.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.dispatch(signOutRequest());
    } else if (error.response?.status >= 500) {
      RenderToast({
        type: "error",
        message: "Server Error",
      });
    } else if (error.message === "Network Error") {
      RenderToast({
        type: "error",
        message: `${error.message} : Please Check Your Network Connection`,
      });
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
